/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/timing" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdTiming } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdTiming = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdTiming,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/timing`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult
);
